"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateReflectMetadata = exports.getReflectMetadata = void 0;
const getReflectMetadata_1 = require("./reflectMetadata/utils/getReflectMetadata");
Object.defineProperty(exports, "getReflectMetadata", { enumerable: true, get: function () { return getReflectMetadata_1.getReflectMetadata; } });
const updateReflectMetadata_1 = require("./reflectMetadata/utils/updateReflectMetadata");
Object.defineProperty(exports, "updateReflectMetadata", { enumerable: true, get: function () { return updateReflectMetadata_1.updateReflectMetadata; } });
//# sourceMappingURL=index.js.map